import { render, staticRenderFns } from "./OnboardingStep01.vue?vue&type=template&id=c0e3583e&scoped=true&"
import script from "./OnboardingStep01.vue?vue&type=script&lang=js&"
export * from "./OnboardingStep01.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingStep01.vue?vue&type=style&index=0&id=c0e3583e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e3583e",
  null
  
)

export default component.exports